<template>
    <common-content-spacer height="small" class="referral-time-slots-preview">
        <div class="selected-slots">
            <div v-for="item in displaySlots" :key="`${item.date}-${item.slot.label}`" class="selected-slots__bar">
                <div class="selected-slots__content">
                    <span class="selected-slots__date">{{ formatDate(item.date) }}:</span>

                    <span class="selected-slots__time">
                        {{ formatTime(item.slot.startTime) }} - {{ formatTime(item.slot.endTime) }}
                    </span>
                </div>

                <common-icon
                    v-if="showDeleteIcon"
                    name="trash-bin"
                    size="medium"
                    class="selected-slots__delete"
                    @click="removeItem(item.slot, item.date)"
                ></common-icon>
            </div>
        </div>
    </common-content-spacer>
</template>

<script>
    import dayjs from 'dayjs'
    export default {
        props: {
            groupSlotsByDate: { type: Object, required: true },
            showDeleteIcon: { type: Boolean, default: false },
        },

        computed: {
            displaySlots() {
                const slots = []

                Object.keys(this.groupSlotsByDate).forEach((date) => {
                    const dateSlots = this.groupSlotsByDate[date] || []

                    dateSlots.forEach((slot) => {
                        slots.push({
                            date,
                            slot,
                        })
                    })
                })

                return slots.slice(0, 3)
            },
        },

        methods: {
            formatDate(dateStr) {
                return dayjs(dateStr).format('ddd - MMM D, YYYY')
            },
            formatTime(timeStr) {
                return dayjs(timeStr, 'HH:mm').format('hh:mm A')
            },

            removeItem(slot, date) {
                this.emitEvent({ name: 'remove-item', payload: { slot, date } })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .referral-time-slots-preview {
        margin-bottom: 30px;
    }

    .selected-slots {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;

        &__bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            min-height: 60px;
            padding: 14px 18px;
            background: #ffffff;
            border: 1px solid #e2e5e9;
            border-radius: 10px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
            box-sizing: border-box;
        }

        &__content {
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: 0;
        }

        &__date {
            font-size: 16px;
            font-weight: 600;
            color: #293241;
            white-space: nowrap;
        }

        &__time {
            font-size: 16px;
            font-weight: 500;
            color: #293241;
            white-space: nowrap;
        }

        &__delete {
            flex-shrink: 0;
            cursor: pointer;

            &:hover {
                color: $color--accent-1;
            }
        }
    }
</style>
